import React from "react";
import { Button as StyledButton } from "./styles";
import { Controls, Player } from "@lottiefiles/react-lottie-player";
import src from "../../assets/jsons/Loading.json";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { ReactComponent as OptionsSVG } from "../../assets/newImages/icons/options.svg";

interface ButtonProps {
  title: string;
  className?: string;
  onClick?: (event) => void;
  type?: "button" | "submit" | "reset";
  width?: string;
  padding?: string;
  disabled?: boolean;
  fontSize?: string;
  loading?: boolean;
  icon?: React.ReactNode;
  iconRight?: boolean;
  onOptionsClick?: (event: React.MouseEvent) => void;
  optionsTitle?: string;
}

export const Button = ({
  title,
  onClick,
  type = "button",
  width = "",
  padding = "7rem",
  disabled = false,
  className,
  loading = false,
  icon,
  iconRight = false,
  onOptionsClick,
  optionsTitle,
}: ButtonProps) => {
  const { theme } = useTheme();

  const hasOptions = !!onOptionsClick;

  return (
    <StyledButton
      onClick={(e) => {
        if (loading) {
          e.preventDefault();
          e.stopPropagation();
          return;
        } else {
          onClick && onClick(e);
        }
      }}
      type={type}
      style={{
        width: width,
        paddingLeft: padding,
        paddingRight: padding,
        opacity: `${disabled ? "0.7" : "1"}`,
        cursor: loading ? "not-allowed" : "pointer",
      }}
      theme={theme}
      disabled={disabled}
      className={className}
    >
      <div
        style={{
          visibility: loading ? "hidden" : "visible",
          display: "flex",
            paddingRight: hasOptions ? "2.5rem" : "0",
          alignItems: "center",
        }}
      >
        {!iconRight && icon}
        {title}
        {iconRight && icon}
      </div>
      {hasOptions && !loading && (
        <>
          <span
            className="options-area"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onOptionsClick(e);
            }}
            title={optionsTitle}
          >
            <OptionsSVG />
          </span>
        </>
      )}
      {loading && (
        <div className="loading">
          <Player
            autoplay
            loop
            src={src}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "3rem",
              width: "100%",
              position: "static",
              right: "0",
              top: "0",
              bottom: "0",
              margin: "auto",
            }}
          >
            <Controls
              visible={false}
              buttons={["play", "repeat", "frame", "debug"]}
            />
          </Player>
        </div>
      )}
    </StyledButton>
  );
};
